import { createFileRoute } from '@tanstack/react-router'
import { TicketDetail } from '@/features/help-center/detail'

export const Route = createFileRoute(
  '/_authenticated/_organization/help-center/$ticketId'
)({
  component: TicketDetail,
})
